import { Form, Radio } from "antd";
import { LabeledField } from "../../../../../common/components/labeledField/labeledField";

export default function UDFRadio({
  title = "",
  isFormItem = true,
  formItemName = "",
  required = true,
  options = [],
  style = {},
  disabled = false,
  extraLabel = null,
}) {
  const radioOptions = options.map((opt) => ({
    label: opt.value,
    value: opt.id,
  }));

  const renderField = () => (
    <Radio.Group
      name="radiogroup"
      options={radioOptions}
      style={style}
      disabled={disabled}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        label={title}
        name={formItemName}
        rules={
          required ? [{ required: true, message: `Choose ${title}` }] : null
        }
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label={title} required={required} extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
}
